export default __webpack_public_path__ + "static/media/check-circle.0bb6ff16.svg";